import AdminOrganization from "@/components/DAdmin/AdminOrganization";

const AdminRoute = [
  {
    path: "/adminorganization",
    name: "AdminOrganization",
    component: AdminOrganization,
    meta: { auth: true },
  },
  {
    path: "/admin/:tab",
    name: "AdminMain",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  {
    path: "/admin/workspaceGroup/:workspaceGroupId",
    name: "AdminWorkspaceGroup",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  {
    path: "/admin/workspaceGroup/:workspaceGroupId/:tab",
    name: "AdminWorkspaceGroupWorkspaces",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  // TODO: enable this when we enter phase 2.

  // {
  //   path: "/admin/workspaceGroup/:workspaceGroupId/:tab",
  //   name: "AdminWorkspaceGroupAdmins",
  //   component: () => import("@/components/DAdmin/AdminMain"),
  //   meta: { auth: true },
  // },
  {
    path: "/admin/workspace/:workspaceId/:tab",
    name: "AdminWorkspaceUsers",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  {
    path: "/admin/workspace/:workspaceId/:tab",
    name: "AdminWorkspaceTeams",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  {
    path: "/admin/workspaces",
    name: "AdminWorkspaces",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  {
    path: "/admin/teams",
    name: "AdminTeams",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
  {
    path: "/admin/allUsers",
    name: "AdminAllUsers",
    component: () => import("@/components/DAdmin/AdminMain"),
    meta: { auth: true },
  },
];

export default AdminRoute;
